import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { PRODUCT_TM } from '../data/content';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white" data-id="element-85" data-mp="9uct7c9ulv5a">
      <div className="mx-auto max-w-page px-3 py-5 sm:px-6 sm:py-7" data-id="element-86" data-mp="9t1lx2h7259f">
        <Reveal className="mx-auto flex max-w-3xl flex-col items-center gap-1 rounded-xl border-2 border-gold bg-mist p-3 text-center sm:p-4" data-id="element-87" data-mp="euh7cvnaadsc">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gold" data-id="element-88" data-mp="jqg00vfnahyk">
            <ShieldCheckIcon size={22} className="text-white" data-id="element-89" data-mp="ns1bqdgg0q76" />
          </span>
          <h2 id="garantia" className="font-display text-base uppercase leading-tight text-navy sm:text-xl" data-id="element-90" data-mp="sldxmftqmiw8">
            🛡️ Garantía de Devolución de 7 Días
          </h2>
          <p className="font-condensed text-lg uppercase tracking-wide text-azure sm:text-2xl" data-id="element-91" data-mp="12kv3oycwiysq">
            Tu compra está protegida
          </p>
          <p className="font-body text-[0.78rem] leading-snug text-steel sm:text-[0.84rem]" data-id="element-92" data-mp="25sgg38xu1xy8">
            Tendrás 7 días para explorar {PRODUCT_TM} y revisar sus módulos,
            ejercicios y bonos. Si consideras que el sistema no es adecuado para
            ti, puedes solicitar un reembolso dentro del período establecido de
            acuerdo con los términos de devolución.
          </p>
        </Reveal>
      </div>
    </section>;
}